import { memo } from 'react';

import usePlankTableStore from '../../hooks/usePlankTableStore';

import TableRow from './TableRow/TableRow';

import tableStyles from './Table.module.css';

const DDPTableRow = memo(TableRow);

const TableMaterieel = () => {
  const rows = usePlankTableStore((state) => state.table.rows);
  return (
    <>
      {rows.length > 0 && (
        <div className={tableStyles.tableRowsStyle}>
          {rows.map((matType) => (
            <DDPTableRow key={matType} matType={matType} />
          ))}
        </div>
      )}
    </>
  );
};
export default TableMaterieel;
